fx.ns("filters.photofilters", class SepiaFilter extends filters.photofilters.BaseFilter {
    
    constructor(parameters)
    {
        super(parameters);

        this.amount = this.params.amount;
        
    };

  
	filterFCN(add)
	{
    	add.colorMatrix('matrix', [ (0.393 + 0.607 * [1 - this.amount]), (0.769 - 0.769 * [1 - this.amount]), (0.189 - 0.189 * [1 - this.amount]), 0, 0,
				                     (0.349 - 0.349 * [1 - this.amount]), (0.686 + 0.314 * [1 - this.amount]), (0.168 - 0.168 * [1 - this.amount]), 0, 0,
				                     (0.272 - 0.272 * [1 - this.amount]), (0.534 - 0.534 * [1 - this.amount]), (0.131 + 0.869 * [1 - this.amount]), 0, 0,
				                     0, 0, 0, 1, 0 ]);
	}
      


});
        